exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro[data-v-446761ec]{padding-top:80px;padding-bottom:80px}.highlighted-text[data-v-446761ec]{border-radius:1em 0 1em 0;background-image:linear-g radient(-100deg,rgba(247,198,2,.05),rgba(247,198,2,.5) 95%,rgba(247,198,2,0))}.border-green-500[data-v-446761ec]{border-style:solid}.child-flex>*[data-v-446761ec],.flex[data-v-446761ec]{-webkit-box-flex:inherit;-ms-flex:inherit;flex:inherit}", ""]);

// exports
